export const getExtension = (filename) => {
  const fileExtensionRegex = /(?:\.([^.]+))?$/;
  const fileExtensionWithoutDot = filename.match(fileExtensionRegex)[1];
  return fileExtensionWithoutDot;
};
export const getMimeType = (file) => {
  let mime;
  if (file.type) {
    mime = file.type;
  } else {
    mime = undefined;
  }
  return mime;
};

export const isExtensionValid = (filename) => {
  if (!filename || typeof filename !== 'string') {
    return false;
  }
  const invalidExtensions = [
    'exe',
    'bin',
    'com',
    'sh',
    'bash',
    'js',
    'jse',
    'htm',
    'html',
    'mjs',
    'bat',
    'msi',
    'cmd',
    'bin',
    'sys',
    'inf',
    'apk',
    'app',
    'ipa',
    'ps1',
    'vbscript',
    'vbs',
    'vb',
    'wsf',
    'wsh',
    'psc1',
    'swf',
  ];

  const extension = getExtension(filename);
  if (!extension) return false;
  return !invalidExtensions.includes(extension.toLowerCase());
};

export const getFileMetaData = (file) => {
  return {
    extension: getExtension(file.name)
      ? getExtension(file.name)
      : 'file without extension',
  };
};
